import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { DropDownList } from '@core/interfaces';
import { ListService } from '@core/services';

import { AuthService } from '@auth/services';

@Component({
  selector: 'z-select-language',
  templateUrl: './select-language.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectLanguageComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  languageList: DropDownList = [];

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(public authService: AuthService, private translocoService: TranslocoService, public listService: ListService) {}

  ngOnInit() {
    this.translocoService
      .selectTranslation()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.initializeStaticDropdownLists();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  selectLanguage(value: string) {
    this.authService.changeLanguageDialog(false);

    if (value) {
      this.authService.setLanguage(value);
    }
  }

  initializeStaticDropdownLists() {
    this.languageList = [
      { column1: 'en', column2: this.translate('core.languages.english') },
      { column1: 'es', column2: this.translate('core.languages.spanish') },
    ];
  }
}
